import {
  ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation
} from '@angular/core';

import {
  IExtendedLink, ILinkMedia, IPushCard, IPushCardWithLayout, PositionEnum, PushSizeEnum,
  SdPushCardComponent, SdThemeComponent
} from '@seb/web-design-system/core';

@Component({
  selector: 'sd-push-panel',
  templateUrl: './push-panel.component.html',
  styleUrls: ['./push-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SdPushCardComponent]
})
export class SdPushPanelComponent extends SdThemeComponent {
  @Input()
  isLoading = false;

  @Input()
  pushFullHeight: IPushCardWithLayout;

  @Input()
  pushTop: IPushCardWithLayout;

  @Input()
  pushBottom: IPushCardWithLayout;

  @Input()
  layout: PositionEnum.left | PositionEnum.right;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel = 3;

  @Input()
  twicPicsAutoSize = true;

  @Output()
  clicked = new EventEmitter<{
    link: IExtendedLink | ILinkMedia;
    title: string;
  }>();

  @Output()
  videoPlayed = new EventEmitter<{ status: string; title: string }>();

  @Output()
  videoEnded = new EventEmitter<{ status: string; title: string }>();

  @Output()
  cardClicked = new EventEmitter<string>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.layout ? 'is-layout-' + this.layout : '']
      .filter(Boolean)
      .join(' ');
  }

  pushSizeEnum = PushSizeEnum;

  onVideoPlayed(push?: IPushCard): void {
    this.videoPlayed.emit({
      status: 'play',
      title: push?.richParagraph?.heading?.data?.title
    });
  }

  onVideoEnded(push?: IPushCard): void {
    this.videoEnded.emit({
      status: 'ended',
      title: push?.richParagraph?.heading?.data?.title
    });
  }

  onClick(event: IExtendedLink | ILinkMedia, push?: IPushCard): void {
    this.clicked.emit({
      link: event,
      title:
        push?.richParagraph?.heading?.data?.title ||
        push?.richParagraph?.heading?.data?.subtitle
    });
  }

  onCardClick(push?: IPushCard): void {
    this.cardClicked.emit(
      push?.richParagraph?.heading?.data?.title ?? 'Card clicked',
    );
  }
}
